import * as React from "react"
import {Box} from "@mui/material";

import {IconSeeker} from "@ui-seeker/core";


export default function actionsColumn() {
    return {
        name: "", label: "Actions",
        options: {
            headerAlign: 'center',
            filter: false,
            customBodyRowRenderLite: (_, rowData) => <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
                <IconSeeker
                    icon="trash"
                    tooltip="Delete Keyword"
                    sx={{ fontSize: '1rem', cursor: 'pointer'  }}
                    //onClick={() => deleteRow(row)}
                />
                <IconSeeker
                    icon="pen"
                    tooltip="Modify Keyword"
                    sx={{ ml: 4, fontSize: '1rem', cursor: 'pointer'  }}
                    //onClick={() => userDrawerFilters.value = row}
                />
            </Box>
        }
    }
}